import { render, staticRenderFns } from "./FacturarDialog.vue?vue&type=template&id=3560a2d7&scoped=true"
import script from "./FacturarDialog.vue?vue&type=script&lang=js"
export * from "./FacturarDialog.vue?vue&type=script&lang=js"
import style0 from "./FacturarDialog.vue?vue&type=style&index=0&id=3560a2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3560a2d7",
  null
  
)

export default component.exports